import { Show, Divider } from 'shared';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { ParticipantSessionRecapType } from 'features/sessions/config/types';
import { getFormattedSessionRecapDate } from 'features/sessions/utils';
import { UserInfoWithSubtitle } from 'features/user/components';

import {
  ModalBody,
  ModalHeader,
  useModalContext,
} from 'shared/components/Modal';
import { Typography } from 'shared/components/Typography';

import { SessionsRecapAttachments } from './Recap/Attachments';
import { SessionsRecapContent } from './Recap/Content';
import { SessionsRecapSubject } from './Recap/Subject';

export const SessionsRecapModal = () => {
  const { sessionRecap } = useModalContext() as {
    sessionRecap: ParticipantSessionRecapType;
  };

  const { title, content, coachProfile, submittedAt, attachments } =
    sessionRecap;

  return (
    <>
      <ModalHeader />
      <ModalBody>
        <Flex>
          <Show when={!!coachProfile}>
            {() => (
              <UserInfoWithSubtitle
                pictureUrl={coachProfile.picture.url}
                name={coachProfile.name}
                subtitle="hOS Coach"
              />
            )}
          </Show>
          <Typography type="small" color="gray">
            {getFormattedSessionRecapDate(submittedAt)}
          </Typography>
        </Flex>
        <Spacer size="md zr" />
        <Divider />
        <Spacer size="md zr" />
        <SessionsRecapSubject subject={title} />
        <SessionsRecapContent content={content} />
        <SessionsRecapAttachments attachments={attachments} />
      </ModalBody>
    </>
  );
};
